import { ICandidateSubmissionSearchFilterVM } from 'wisestep-api';

import axios from '../../../axios';
import IBusinessDefinitionSetting from '../types/BusinessDefinition';
import BUUpdateOrderReq from '../types/BUUpdateOrderReq';
import ICandidateStageStatusPipelineSetting from '../types/ICandidateStageStatusPipelineSetting';

export const getStageStatusByCurrentUser = () =>
  axios.get('/candidatesearch/api/candidate-stage-status-pipeline-settings');

export const getStageStatusById = (id: string) =>
  axios.get(`/candidatesearch/api/candidate-stage-status-pipeline-settings/${id}`);

export const saveStageStatusByCurrentUser = (payload: ICandidateStageStatusPipelineSetting) =>
  axios.post('/candidatesearch/api/candidate-stage-status-pipeline-settings', payload);

export const resetToDefaultStageStatus = () =>
  axios.post('/candidatesearch/api/candidate-stage-status-pipeline-settings/reset-to-default');

export const saveBusinessDefinition = (payload: IBusinessDefinitionSetting) =>
  axios.post('/candidatesearch/api/business-definition-settings/save', payload);

export const getAllBusinessDefinition = () =>
  axios.get('/candidatesearch/api/business-definition-settings/getAll');

export const getByIdBusinessDefinition = (id: string) =>
  axios.get(`/candidatesearch/api/business-definition-settings/get/${id}`);

export const deleteByIdBusinessDefinition = (id: string) =>
  axios.delete(`/candidatesearch/api/business-definition-settings/delete/${id}`);

export const updateArchiveByIdBusinessDefinition = (id: string, isArchive: boolean) =>
  axios.put(`/candidatesearch/api/business-definition-settings/update/${id}/${isArchive}`);

export const updateBusinessDefinitionNameById = (id: string, name: string, jobOption: string) =>
  axios.put(`/candidatesearch/api/business-definition-settings/update/${id}/${name}/${jobOption}`);

export const updateBusinessDefinitionOrderById = (req: BUUpdateOrderReq) =>
  axios.put(`/candidatesearch/api/business-definition-settings/update-display-order`, req);

export const getAllBusinessDefinitionWithCount = (payload: ICandidateSubmissionSearchFilterVM) =>
  axios.post('candidatesearch/api/submission/business-definition-count', payload);
